// extracted by mini-css-extract-plugin
export default {"root":"LoginForm_root__vI8sm","forgotPassBtn":"LoginForm_forgotPassBtn__PCYlN","passwordWrapper":"LoginForm_passwordWrapper__YLR8c"};